"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STATE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _localization = require("@lt/localization");

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Link = _interopRequireDefault(require("../Link"));

var _PricewatchSubscribeFormHeader = _interopRequireDefault(require("./PricewatchSubscribeFormHeader"));

var _PricewatchSubscribeFormEdit = _interopRequireDefault(require("./PricewatchSubscribeFormEdit"));

var _PricewatchSubscribeFormSubmit = _interopRequireDefault(require("./PricewatchSubscribeFormSubmit"));

var _PricewatchSubscribeFormCancelButton = _interopRequireDefault(require("./PricewatchSubscribeFormCancelButton"));

var _PricewatchSubscribeFormRetryButton = _interopRequireDefault(require("./PricewatchSubscribeFormRetryButton"));

var _PricewatchSubscribeFormDescription = _interopRequireDefault(require("./PricewatchSubscribeFormDescription"));

var _PricewatchSubscribeBackground = _interopRequireDefault(require("./PricewatchSubscribeBackground"));

var _Context = require("./Context");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var STATE = {
  DEFAULT: 'default',
  EDIT: 'edit',
  DONE: 'done',
  ERROR: 'error'
};
exports.STATE = STATE;

var handleEnter = function handleEnter(e) {
  return e.key === 'Enter' && e.preventDefault();
};

var PricewatchSubscribeForm = function PricewatchSubscribeForm(_ref) {
  var className = _ref.className,
      isMobile = _ref.isMobile,
      defaultEmail = _ref.email,
      viewParams = _ref.viewParams,
      subscriptionParams = _ref.subscriptionParams,
      onSubmit = _ref.onSubmit,
      setIsSubscribedOnPrice = _ref.setIsSubscribedOnPrice,
      onCancel = _ref.onCancel,
      dataLayerPush = _ref.dataLayerPush,
      dataLayerPushParams = _ref.dataLayerPushParams;

  var _useState = (0, _react.useState)(isMobile ? STATE.EDIT : STATE.DEFAULT),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultEmail),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      hotelStars = _useState6[0],
      setHotelStars = _useState6[1];

  var _useState7 = (0, _react.useState)(email),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      isSubmitable = _useState8[0],
      setSubmitable = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      spamConsent = _useState10[0],
      setSpamConsent = _useState10[1];

  var _useState11 = (0, _react.useState)(undefined),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      isNotConfirmedUser = _useState12[0],
      setNotConfirmedUser = _useState12[1];

  var params = {
    isMobile: isMobile,
    viewParams: viewParams,
    subscriptionParams: subscriptionParams,
    defaultEmail: defaultEmail,
    state: state,
    setState: setState,
    STATE: STATE,
    email: email,
    setEmail: setEmail,
    hotelStars: hotelStars,
    setHotelStars: setHotelStars,
    isSubmitable: isSubmitable,
    spamConsent: spamConsent,
    setSubmitable: setSubmitable,
    onCancel: onCancel,
    dataLayerPush: dataLayerPush,
    dataLayerPushParams: dataLayerPushParams,
    isNotConfirmedUser: isNotConfirmedUser,
    setNotConfirmedUser: setNotConfirmedUser
  };
  return /*#__PURE__*/_react["default"].createElement(_Context.SubscribeContextProvider, {
    value: _objectSpread({}, params)
  }, /*#__PURE__*/_react["default"].createElement(StyledPricewatchSubscribeForm, {
    state: state,
    isMobile: isMobile,
    className: className,
    onKeyDown: handleEnter
  }, /*#__PURE__*/_react["default"].createElement(_PricewatchSubscribeFormHeader["default"], null), /*#__PURE__*/_react["default"].createElement(_PricewatchSubscribeFormEdit["default"], null), /*#__PURE__*/_react["default"].createElement(_PricewatchSubscribeFormDescription["default"], null), /*#__PURE__*/_react["default"].createElement(_PricewatchSubscribeFormSubmit["default"], {
    onSubmit: onSubmit,
    setIsSubscribedOnPrice: setIsSubscribedOnPrice
  }), /*#__PURE__*/_react["default"].createElement(_PricewatchSubscribeFormRetryButton["default"], null), isMobile && (state === STATE.DONE || state === STATE.ERROR) && /*#__PURE__*/_react["default"].createElement(CancelButton, {
    functional: state === STATE.ERROR
  }), (state === STATE.DEFAULT || state === STATE.EDIT) && /*#__PURE__*/_react["default"].createElement(Background, {
    height: state === STATE.EDIT ? 151 : 96
  }), state === STATE.EDIT && /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    isMobile: isMobile,
    checked: spamConsent,
    onChange: function onChange() {
      return setSpamConsent(!spamConsent);
    }
  }, /*#__PURE__*/_react["default"].createElement(_localization.Trans, {
    i18nKey: "subscribe.checkbox",
    components: {
      Link: /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        href: "/articles/advertising"
      })
    }
  }))));
};

var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "PricewatchSubscribeForm__StyledCheckbox",
  componentId: "sc-pln9q8-0"
})(["margin-top:10px;font-size:12px;color:", ";", ";"], function (props) {
  return props.theme.colors.greyLight;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && "\n    white-space: break-spaces;\n    font-size: 16px;\n  ";
});
var Background = (0, _styledComponents["default"])(_PricewatchSubscribeBackground["default"]).withConfig({
  displayName: "PricewatchSubscribeForm__Background",
  componentId: "sc-pln9q8-1"
})(["position:absolute;bottom:0;left:0;right:0;width:100%;pointer-events:none;"]);

var StyledPricewatchSubscribeForm = _styledComponents["default"].form.withConfig({
  displayName: "PricewatchSubscribeForm__StyledPricewatchSubscribeForm",
  componentId: "sc-pln9q8-2"
})(["position:relative;width:100%;padding:20px 8px 8px;", " ", " ", " ", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return (0, _styledComponents.css)(["background:", ";border-radius:", ";"], theme.colors.white, theme.shape.borderRadiusBig);
}, function (_ref4) {
  var state = _ref4.state;
  return (state === STATE.DONE || state === STATE.ERROR) && (0, _styledComponents.css)(["align-items:center;text-align:center;"]);
}, function (_ref5) {
  var state = _ref5.state;
  return state === STATE.EDIT && (0, _styledComponents.css)(["box-shadow:0px 1px 2px rgba(210,208,197,0.9),0px 10px 15px rgba(216,214,204,0.9);border-radius:4px;"]);
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && (0, _styledComponents.css)(["padding:48px 16px 16px;min-width:320px;width:auto;height:100%;min-height:500px;display:flex;flex-direction:column;"]);
});

var CancelButton = (0, _styledComponents["default"])(_PricewatchSubscribeFormCancelButton["default"]).withConfig({
  displayName: "PricewatchSubscribeForm__CancelButton",
  componentId: "sc-pln9q8-3"
})(["", ""], function (_ref7) {
  var functional = _ref7.functional;
  return functional && "\n    margin-top: 14px;\n  ";
});
PricewatchSubscribeForm.propTypes = {
  isMobile: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func,
  dataLayerPush: _propTypes["default"].func,
  dataLayerPushParams: _propTypes["default"].func,
  email: _propTypes["default"].string,
  viewParams: _propTypes["default"].shape({
    countryRu: _propTypes["default"].string,
    startDate: _propTypes["default"].string,
    nightCount: _propTypes["default"].number,
    hasFlexDates: _propTypes["default"].bool,
    hasFlexNights: _propTypes["default"].bool
  }).isRequired,
  subscriptionParams: _propTypes["default"].shape({
    adults: _propTypes["default"].number,
    nights: _propTypes["default"].arrayOf(_propTypes["default"].number),
    kids: _propTypes["default"].arrayOf(_propTypes["default"].number),
    place_ids: _propTypes["default"].arrayOf(_propTypes["default"].number),
    departure_ids: _propTypes["default"].arrayOf(_propTypes["default"].number),
    start_date_from: _propTypes["default"].string,
    start_date_to: _propTypes["default"].string
  }).isRequired
};
PricewatchSubscribeForm.defaultProps = {
  onCancel: null,
  dataLayerPush: Function.prototype,
  dataLayerPushParams: Function.prototype,
  isMobile: false,
  className: '',
  email: ''
};

var _default = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeForm);

exports["default"] = _default;